var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaybackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43.8965,
    height: 43.8965,
    rx: 9,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10C30.2843 10 37 16.7157 37 25C37 33.2843 30.2843 40 22 40C13.7157 40 7 33.2843 7 25C7 19.8765 9.56868 15.353 13.4885 12.6471",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 5L20 10.5L25.5 16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.7679C29.3333 24.5377 29.3333 26.4623 28 27.2321L19.75 31.9952C18.4167 32.765 16.75 31.8027 16.75 30.2631L16.75 20.7369C16.75 19.1973 18.4167 18.235 19.75 19.0048L28 23.7679Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybackIcon);
export default __webpack_public_path__ + "static/media/playback-icon.a0e36c4ace66a5cd6f7f7a09d1879b89.svg";
export { ForwardRef as ReactComponent };